$( document ).ready(function() {
  const sellingPlans = {};
  
  // App Settings
  const discountPercent = '5';
  sellingPlans['weekly'] = '1230733357';
  sellingPlans['bi-weekly'] = '1230667821';
  sellingPlans['monthly'] = '1230635053';
  sellingPlans['bi-monthly'] = '1230700589';
  const freeDrag = false; // Expirimental feature -- leave off for production

  // UI Settings
  const touchSwipeSensitivity = 15; // Lower number is more sensitive
  
  // Scale Settings
  const responsiveScalingFactor = 20;
  const bounce = 15;
  const totalRotationDefault = 45;
  const normalDotWidth = 0.35;
  const activeDotWidth = 1.3;
  const normalDotColor = '#CCC';
  const activeDotColor = '#4F4F4F';

  // Global Vars
  var mouseDown = false;
  var slideLock = false;
  var direction = 0;  
  var curIndex = 0;
  var nextIndex = 1;
  var startX;
  var deviation;
  var scrollLeft;
  var lastActiveSelector;
  var lastActiveSlider;
  var lastSlideWidth;

  // Class Definitions
  const subWrapperClass = '.tcw-sub-wrapper';
  const selectorWrapperClass = '.tcw-sub-selector'
  const slideWrapperClass = '.tcw-sub-slide-wrapper';
  const slideClass = '.tcw-sub-slide';
  const dotWrapperClass = '.tcw-sub-slide-dots';
  const dotClass = '.tcw-sub-slide-dot';

  const navBtnClass = '.tcw-sub-slide-nav-btn';
  const navBtnNextClass = '.nav-btn-next';
  const navBtnPrevClass = '.nav-btn-prev';
  
  const prodSelectClass = '.tcw-sub-product-select';  
  const optionSelectClass = '.tcw-sub-option-select';
  const optionSelectValueClass = '.tcw-sub-option-select-value';
  const frequencySelectClass = '.tcw-sub-frequency-select';
  
  const priceDisplayClass = ".tcw-sub-purchase-price";
  const buyButtonClass = ".tcw-sub-buy-button";
  const dataStoreClass = ".tcw-sub-product-data-storage-wrapper";

  // Element Selectors
  const subWrapper = $(subWrapperClass);
  const selectWrappers = $(selectorWrapperClass);
  const slideWrappers = $(slideWrapperClass);
  
  const navButtons = $(navBtnClass);
  
  
  
  // Set font size of Select Wrappers to help with responsive scaling
  $(prodSelectClass).css('font-size', ($(prodSelectClass).width() / responsiveScalingFactor)+'px');
  $(optionSelectClass).css('font-size', ($(optionSelectClass).width() / responsiveScalingFactor)+'px');
  $(frequencySelectClass).css('font-size', ($(frequencySelectClass).width() / responsiveScalingFactor)+'px');

  // Update selected variant for initial page load
  updateSelectedVariant();

  
  // Mouse events for normal swipe / click functionality
  if(!freeDrag) {
    let touchstartX = 0;
    let touchendX = 0;

    // Disable dragging on slide wrappers
    slideWrappers.on("touchmove", false);
    
    slideWrappers.on('touchstart', function(e) {
      // Slow down our crazy fingered friends
      if (slideLock) return;
      
      // Record touch start x coord
      touchstartX = e.changedTouches[0].screenX;
      
      // Refresh the last active slider variables if needed
      if(!$(this).is(lastActiveSlider)) {
        refreshLastActive($(this));
      }
    });
    
    $(document).on('touchend', function(e) {
      // Record touch end x coord
      touchendX = e.changedTouches[0].screenX;

      // If this touch started on a slider -- process a swipe
      if(touchstartX) { processSwipe() }
    });

    // Navigation button handlers for desktop
    navButtons.on('click', function(e) {
      let direction;

      // Slow down our crazy fingered friends
      if (slideLock) return;
      
      // Find parent slider of this button
      let slider = $(this).parent().siblings(slideWrapperClass);

      // Determine navigation direction
      if($(this).hasClass("nav-btn-next")) {
        direction = 1;
      }
      else if($(this).hasClass("nav-btn-prev")) {
        direction = 2;
      } else {
        return;
      }

      // Refresh the last active slider variables if needed
      if(!slider.is(lastActiveSlider)) {
        refreshLastActive(slider);
      }

      // Process slider navigation
      moveSlider(direction);
      
    });

    function processSwipe() {
      let touchMoveDistance;

      // Swipe Left (Next)
      if (touchendX < touchstartX) {
        touchMoveDistance = touchstartX - touchendX;
        
        // Check if swipe qualifies
        if(touchMoveDistance < touchSwipeSensitivity) {
          console.log('Tiny Swipe: '+touchMoveDistance);
          moveSlider(null);
        } else {
          moveSlider(1);
        }
      }

      // Swipe Right (Prev)
      if (touchendX > touchstartX) {
        touchMoveDistance = touchendX - touchstartX;

        // Check if swipe qualifies
        if(touchMoveDistance < touchSwipeSensitivity) {
          console.log('Tiny Swipe: '+touchMoveDistance);
          moveSlider(null);
        } else {
          moveSlider(2);
        }
      }

      if(touchendX == touchstartX) {
        console.log('Tapping is Disabled');
        moveSlider(null);
      }

      // Reset touch params
      touchstartX = 0;
      touchendX = 0;
      
    }

    // 0 = Bounce, 1 = Left (Next), 2 = Right (Prev)
    function moveSlider(direction) {
      let scrollTo;
      let oldIndex = curIndex;
      var newIndex;

      slideLock = true;
      
      lastActiveSelector = $(selectorWrapperClass+'.active');
      lastActiveSlider = $(slideWrapperClass+'.active');
      autoStartX = lastActiveSlider.scrollLeft();

      // Determine active slide count
      let optionSelectClassName = optionSelectClass.replace(".", "");
      let isOptionSlider = lastActiveSelector.hasClass(optionSelectClassName);
      if(isOptionSlider) {
        lastActiveSliderSlideCount = lastActiveSlider.find(slideClass+'.visible').length;
      } else {
        lastActiveSliderSlideCount = lastActiveSlider.find(slideClass).length;
      }

      // Next
      if(direction == 1) {
        newIndex = Math.round((lastActiveSlider.scrollLeft() + lastSlideWidth) / lastSlideWidth);
        
        if(newIndex < 1) { newIndex = 0 }
        if(newIndex >= lastActiveSliderSlideCount) { newIndex = oldIndex }
        
        scrollTo = (lastSlideWidth * newIndex) + bounce;         
      }
      // Prev
      else if(direction == 2) {
        newIndex = Math.round((lastActiveSlider.scrollLeft() - lastSlideWidth) / lastSlideWidth);

        if(newIndex < 1) { newIndex = 0 }
        if(newIndex >= lastActiveSliderSlideCount) { newIndex = oldIndex }

        scrollTo = (lastSlideWidth * newIndex) - bounce;
      }
      // Bounce
      else {
        newIndex = oldIndex;
        scrollTo = (lastSlideWidth * newIndex) + bounce;
      }

      scrollLand = lastSlideWidth * newIndex;
      lastActiveSlider.animate( { scrollLeft: scrollTo }, 400);
      lastActiveSlider.animate( { scrollLeft: scrollLand }, 200, function() {
        console.log(Math.round(lastActiveSlider.scrollLeft()));
        console.log(lastSlideWidth);
        console.log(newIndex);
        if(Math.round(lastActiveSlider.scrollLeft()) == lastSlideWidth * newIndex) {
          // Update actives and options if needed
          updateActive(lastActiveSelector, lastActiveSlider, newIndex);
          updateOptions();

          setTimeout(function(){
             curIndex = newIndex;
          }, 200);
          
          slideLock = false;
        }
      }); 
    }

    function refreshLastActive(slider) {
      curIndex = slider.find(slideClass+'.active').data('index');
      lastSlideWidth = Math.round(slider.find(slideClass+'[data-index="0"]').width());

      $(selectorWrapperClass).removeClass('active');
      slider.parents(selectorWrapperClass).addClass('active');
      $(slideWrapperClass).removeClass('active');
      slider.addClass('active');
      
      lastActiveSelector = $(selectorWrapperClass+'.active');
      lastActiveSlider = $(slideWrapperClass+'.active');
    }
  } else {

    lockInt = setInterval(function(){
       slideLock = false;
    }, 1000);
    
    // Global Mouse Up
    $(document).on('touchend mouseup', function(e){
    e.preventDefault();
      mouseDown = false;

      
  //    slideLock = true;
      
      lastActiveSelector = $(selectorWrapperClass+'.active');
      lastActiveSlider = $(slideWrapperClass+'.active');
      
      let lastSlideWidth = Math.floor(lastActiveSlider.find(slideClass+'[data-index="0"]').width());
      let oldIndex = curIndex;
      let scrollTo;
      var newIndex;
  
      autoStartX = lastActiveSlider.scrollLeft() + deviation;
      
      if(direction < 0) {
        newIndex = Math.round((lastActiveSlider.scrollLeft() + lastSlideWidth / 4) / lastSlideWidth);
        if(newIndex < 1) { newIndex = 0 }
        
        if(oldIndex !== newIndex) {
          scrollTo = lastSlideWidth * newIndex + bounce;
        } else {
          scrollTo = lastSlideWidth * newIndex;
        }
      } else {
        newIndex = Math.round((lastActiveSlider.scrollLeft() - lastSlideWidth / 4) / lastSlideWidth);
        if(newIndex < 1) { newIndex = 0 }
  
        if(oldIndex !== newIndex) {
          scrollTo = lastSlideWidth * newIndex - bounce;
        } else {
          scrollTo = lastSlideWidth * newIndex;
        }
      }
      
      // If last active slider is already home, clean up
      if(lastActiveSlider.scrollLeft() == lastSlideWidth * newIndex) {
        // Update actives and options if needed
        updateActive(lastActiveSelector, lastActiveSlider, newIndex);
        updateOptions();
        
        curIndex = newIndex;
      } else {
        scrollLand = lastSlideWidth * newIndex;
        lastActiveSlider.animate( { scrollLeft: scrollTo }, 400);
        lastActiveSlider.animate( { scrollLeft: scrollLand }, 200, function() {
          if(lastActiveSlider.scrollLeft() == lastSlideWidth * newIndex) {
            // Update actives and options if needed
            updateActive(lastActiveSelector, lastActiveSlider, newIndex);
            updateOptions();
           
            setTimeout(function(){
               curIndex = newIndex;
            }, 200);
          }
        });
      }    
    });
  
    
    // Slide Mouse Down Listeners
    slideWrappers.on('touchstart mousedown', function(e){
  //    e.preventDefault();
  
      // Slow down our crazy fingered mobile friends
      if (slideLock) return;
      
      mouseDown = true;
      startX = e.pageX - $(this).offset().left;
      scrollLeft = $(this).scrollLeft();
      
      // Refresh the last active slider variables if needed
      if(!$(this).is(lastActiveSlider)) {
        curIndex = $(this).find(slideClass+'.active').data('index');
        lastSlideWidth = Math.floor($(this).find(slideClass+'[data-index="0"]').width());
  
        $(selectorWrapperClass).removeClass('active');
        $(this).parents(selectorWrapperClass).addClass('active');
        $(slideWrapperClass).removeClass('active');
        $(this).addClass('active');
        
        lastActiveSelector = $(selectorWrapperClass+'.active');
        lastActiveSlider = $(slideWrapperClass+'.active');
      }    
    });
  
    
    // Slide Mouse Move Listeners
    slideWrappers.on('touchmove mousemove', function(e){
      e.preventDefault();
      if (!mouseDown) return;
      
      // Slow down our crazy fingered mobile friends
      if (slideLock) return; 
      
      var x = e.pageX - $(this).offset().left;
      deviation = x - startX;
      $(this).scrollLeft(scrollLeft - deviation);
    });
  }

  
  // Slide Scroll Listeners
  slideWrappers.on( "scroll", function(e) {
    e.preventDefault();

    let isProductSlide = $(this).parents(prodSelectClass).length ? 1 : 0;
    let enableRotations = $(this).hasClass('tcw-sub-slide-rotation') ? 1 : 0;
    let requestedRotation = $(this).data('total-rotation');
    let totalRotation = requestedRotation ? requestedRotation : totalRotationDefault;
    var curSliderPos = $(this).scrollLeft();
    var activeSlide = $(this).children(slideClass+'.active').data('index');
    var sliderSlideCount = 0;
    var relativeMovement;

    // Determine if movement is user generated or triggered by mouseup
    if (mouseDown) {
      relativeMovement = deviation;
    } else {
      relativeMovement = (curSliderPos - autoStartX)*-1;
    }

    // Determine direction of relative movement
    if(relativeMovement > 0) {
      direction = 1;
      if(curSliderPos < lastSlideWidth * curIndex) {
        nextIndex = curIndex - 1;
        if(nextIndex < 1) { nextIndex = 0 }
      } else {
        nextIndex = curIndex;
      }
    } else if(relativeMovement < 0) {
      direction = -1;
      if(curSliderPos > lastSlideWidth * curIndex) {
        nextIndex = curIndex + 1;
      } else {
        nextIndex = curIndex;
      }
    }
    
    curIndexHome = lastSlideWidth * curIndex;
    nextIndexHome = lastSlideWidth * nextIndex;

    // Handle Animations
    $(this).parents(selectorWrapperClass).find(slideClass).each(function() {
      let slideIndex = $(this).data('index');
      let slideHome = lastSlideWidth * slideIndex;
      let slideRelative = slideIndex - activeSlide;
      let sliderPadding = sliderSlideCount * slideIndex;
      let dotElement = lastActiveSelector.find(dotClass+'[data-index="'+slideIndex+'"]');
      
      var dotWidth;
      var dotColor;
     
      if(slideRelative > 0) {
        dotWidth = (activeDotWidth + normalDotWidth) + (curSliderPos - slideHome) / (lastSlideWidth / activeDotWidth);
        dotColor = ((curSliderPos - slideHome)*-1) / (lastSlideWidth / 100);
      } else if(slideRelative < 0) {
        dotWidth = (activeDotWidth + normalDotWidth) + ((curSliderPos - slideHome)*-1) / (lastSlideWidth / activeDotWidth);
        dotColor = (curSliderPos - slideHome) / (lastSlideWidth / 100);
      } else {
        dotWidth = activeDotWidth + ((curSliderPos - slideHome)*direction) / (lastSlideWidth / activeDotWidth);
        dotColor = (((curSliderPos - slideHome)*direction) / (lastSlideWidth / 100)) + 100;
      }

      dotWidth = dotWidth.toFixed(2);
      dotColor = dotColor.toFixed(2);

      // Handle Dot Width
      if(dotWidth <= activeDotWidth && dotWidth >= normalDotWidth) {
        dotElement.width(dotWidth+'em');
      }
      
      // Handle Dot Color
      if(dotColor <= 100 && dotColor >= 0) {
        if(slideRelative != 0) {
          dotElement.css({'background-color' : 'color-mix(in srgb, '+normalDotColor+' '+dotColor+'%, '+activeDotColor+')'});
        } else {
          dotElement.css({'background-color' : 'color-mix(in srgb, '+activeDotColor+' '+dotColor+'%, '+normalDotColor+')'});
        }
      }

      // If rotation is enabled on this slider
      if(enableRotations) {
        var slideRotation = ((((curSliderPos - sliderPadding) - slideHome) / (lastSlideWidth / totalRotation))*-1).toFixed(2);
        
        // Handle Rotations
        if(slideRotation <= totalRotation && slideRotation >= totalRotation*-1) {
          $(this).css({'transform' : 'rotate('+ slideRotation +'deg)'})
        }
      }
      
      // "Product Select" slide wrapper specific functions
      if(isProductSlide) {
        var infoElements = lastActiveSelector.find(prodSelectClass+'-title[data-index="'+slideIndex+'"], '+prodSelectClass+'-subtitle[data-index="'+slideIndex+'"], '+prodSelectClass+'-feature[data-index="'+slideIndex+'"]');

        // Handle title and feature animations
        if(slideRelative > 0) {
          infoElements.css('opacity', 1 - (((curSliderPos - slideHome)*-1) / (lastSlideWidth)));
        } else if(slideRelative < 0) {
          infoElements.css('opacity', 1 - ((curSliderPos - slideHome) / (lastSlideWidth)));
        } else {
          infoElements.css('opacity', 1 - (((curSliderPos - slideHome)*-direction) / (lastSlideWidth)));
        }
      }
    });
  });

  
  function updateSelectedVariant() {
    let priceDisplay = $(priceDisplayClass);
    let buyButton = $(buyButtonClass);
    let dataStorage = $(dataStoreClass);
    let activeProduct = $(prodSelectClass+'-slide.active').data('index');
    let activeOptions = $(optionSelectClass);
    let activeFrequency = $(frequencySelectClass+'-slide.active').data('value');
    var searchKey = '';

    activeOptions.each(function() {
      let selectorOption = $(this).data('option');
      let selectorValue = $(this).find(slideClass+'.active '+optionSelectValueClass).html();
      searchKey = searchKey + '[data-' + selectorOption + '="'+selectorValue+'"]';
    });

    var dataProduct = dataStorage.find('product[data-index="'+activeProduct+'"]');
    var variant = dataProduct.find('variant'+searchKey);
    var variantID = variant.data('id');
    var price = variant.data('price');
    var frequency = sellingPlans[activeFrequency];

    if(discountPercent) {
      var discountPrice = price - (price * (discountPercent / 100));
// console.log(discountPrice);
      priceDisplay.find('span').html('$'+discountPrice.toFixed(2));
      priceDisplay.find('s').html('$'+price);
      priceDisplay.find('s').show();
    } else {
      priceDisplay.find('span').html('$'+price);
      priceDisplay.find('s').html('');
      priceDisplay.find('s').hide();      
    }

//    var boldURL = '/cart/clear?return_to=/cart/add?items[][id]='+variantID+'&items[][quantity]=1&items[][selling_plan]='+frequency+'&return_to=/checkout';
    var boldURL = '/cart/add?items[][id]='+variantID+'&items[][quantity]=1&items[][selling_plan]='+frequency;
    buyButton.attr('href', boldURL);
  }
  
  // Update active / selected elements for last active slider
  function updateActive(selector, slider, newIndex) {
    if(slider.parents(optionSelectClass).length) {
      let activeProduct = $(prodSelectClass+'-slide.active').data('index');
      slider.find(slideClass).removeClass('active');
      slider.find(slideClass+'[data-index="'+newIndex+'"][data-product-index="'+activeProduct+'"]').addClass('active');
    } else {
      slider.find(slideClass).removeClass('active');
      slider.find(slideClass+'[data-index="'+newIndex+'"]').addClass('active');
    }
      
    selector.find(dotClass).removeClass('active');
    selector.find(dotClass+'[data-index="'+newIndex+'"]').addClass('active');
    selector.find(dotClass).not('.active').width(normalDotWidth+'em');
    selector.find(dotClass+'.active').width(activeDotWidth+'em');
    
    if(slider.parents(prodSelectClass).length) {
      selector.find(prodSelectClass+'-title, '+prodSelectClass+'-subtitle, '+prodSelectClass+'-feature').removeClass('active');
      selector.find(prodSelectClass+'-title[data-index="'+newIndex+'"], '+prodSelectClass+'-subtitle[data-index="'+newIndex+'"], '+prodSelectClass+'-feature[data-index="'+newIndex+'"]').addClass('active');
      selector.find(prodSelectClass+'-slide[data-index="'+newIndex+'"]').css({'transform' : 'rotate(0deg)'});
      selector.find(prodSelectClass+'-title, '+prodSelectClass+'-subtitle, '+prodSelectClass+'-feature').not('.active').css('opacity', '0');
      selector.find(prodSelectClass+'-title.active, '+prodSelectClass+'-subtitle.active, '+prodSelectClass+'-feature.active').css('opacity', '1');
    }
  }

  // Update all option selectors to only show options for the current product
  function updateOptions() {
    let activeProduct = $(prodSelectClass+'-slide.active').data('index');
    
    // Check each option selector to see if it needs to be updated
    $(optionSelectClass+'-slide-wrapper').each(function() {
      if($(this).data('selected-product') == activeProduct) {
        return;
      }
      
      var currentSelectedOption = $(this).find(slideClass+'.active').data('index');
      var totalNewOptions = $(this).find(slideClass+'[data-product-index="'+activeProduct+'"]').length;
      var totalCurrentDots = $(this).parents(optionSelectClass).find(dotClass).length;
      var dotAdjustment = totalNewOptions - totalCurrentDots;

      $(this).data('selected-product', activeProduct);      

      $(this).find(slideClass).removeClass('active');
      $(this).find(slideClass+'[data-index="'+currentSelectedOption+'"][data-product-index="'+activeProduct+'"]').addClass('active');

      $(this).find(slideClass).removeClass('visible');
      $(this).find(slideClass+'[data-product-index="'+activeProduct+'"]').addClass('visible');

      $(this).find(slideClass+'[data-product-index="'+activeProduct+'"]').reverse().each(function() {
        $(this).parent().prepend(this);
      });
      

      if(dotAdjustment != 0) {
        var dotWrapper = $(this).parents(optionSelectClass).find(dotWrapperClass);
        if(dotAdjustment > 0) {
          for (let i = 0; i < dotAdjustment; i++) {
            var newDotIndex = totalCurrentDots + i;
            var newDot = $(this).parents(optionSelectClass).find(dotClass+'[data-index="0"]').clone().appendTo(dotWrapper);
            
            newDot.removeClass('active');
            newDot.attr('data-index', newDotIndex);
            newDot.attr('style', '');
            newDot.appendTo(dotWrapper);
          }
        } else {
          dotAdjustment = dotAdjustment*-1;
          for (let i = 0; i < dotAdjustment; i++) {
            var lastDot = $(this).parents(optionSelectClass).find(dotClass+':last');
            
            if(lastDot.hasClass('active')) {
              var lastDotIndex = lastDot.data('index') - dotAdjustment;
              var newSelectedDot = $(this).parents(optionSelectClass).find(dotClass+'[data-index="'+ lastDotIndex +'"]');
              
              newSelectedDot.addClass('active');
              newSelectedDot.width(activeDotWidth+'em');
              newSelectedDot.css('background-color', '');
            }
            
            lastDot.remove();
          } 
        }
      }
    });

    updateSelectedVariant();
  }
  
});

jQuery.fn.reverse = [].reverse;